import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'semantic-ui-react';
import NumberInput from 'semantic-ui-react-numberinput';
import { useIntl } from 'react-intl';
import { firstError, firstResponseError, pruneServerErrors } from '@/utils/errors';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import fields from '@/constants/fields';
import FormValidationError from '@/components/errors/FormValidationError';
import Dialog from '@/components/dialogs/Dialog';
import { hideEditCohortSettings, updateCohortSettingsProperties, updateDatasetSettings } from '../actions';

const DatasetCohortSettingsDialog = ({
  category,
  code,
  hide,
  minCohortSize,
  originalMinCohortSize,
  saveErrors,
  saveStatus,
  theme,
  title,
  updateCohortSetting,
  updateSettings,
}) => {
  const intl = useIntl();
  const submitForm = () => updateSettings(category, code, { minimum_cohort_size: minCohortSize }, title);
  const minCohortSizeError = saveErrors.find((e) => (e.fields.includes(fields.MINIMUM_COHORT_SIZE)));

  return (
    <Dialog
      className="aridhia-dataset-cohort-settings"
      error={firstResponseError(saveErrors)}
      icon="filter"
      inProgress={saveStatus === states.PENDING}
      message="dataset.settings.cohort.minimum.size.header"
      messageicon="stop circle"
      minimumDataEntryMet={minCohortSize !== originalMinCohortSize}
      onClose={hide}
      onSave={submitForm}
      onDismiss={() => updateCohortSetting({ saveErrors: pruneServerErrors(saveErrors) })}
      saveMessageId="actions.apply"
      title={intl.formatMessage({ id: 'settings.cohort.edit.title' })}
      theme={theme}
    >
      <Form autoComplete="off" onSubmit={submitForm} error={firstError(saveErrors) !== null}>
        <FormValidationError
          error={minCohortSizeError}
          htmlFor="cohort_setting_min_size"
          labelId="save.dataset.settings.cohort.minimum.size"
          position="right"
        >
          <NumberInput
            allowEmptyValue={false}
            value={minCohortSize ? minCohortSize.toString() : '0'}
            onChange={(value) => updateCohortSetting({ minimum_cohort_size: parseInt(value, 10) })}
          />
        </FormValidationError>
      </Form>
    </Dialog>
  );
};

const mapStateToProps = ({
  datasetSettings: {
    cohortSettings: {
      category, code, minimum_cohort_size: minCohortSize, saveStatus, saveErrors, title,
    },
    settings,
  },
}) => {
  const item = findResult(settings, category, code);

  return {
    category,
    code,
    minCohortSize,
    originalMinCohortSize: item?.minimum_cohort_size,
    saveErrors,
    saveStatus,
    title,
  };
};
const mapDispatchToProps = {
  hide: hideEditCohortSettings,
  updateCohortSetting: updateCohortSettingsProperties,
  updateSettings: updateDatasetSettings,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetCohortSettingsDialog);
